// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-footer {
  z-index: 999;
}

.cart-amount {
  font-size: 1rem;
  border: 1px solid;
  border-radius: 10px;
  min-width: 22px;
  height: auto;
  text-align: center;
  position: absolute;
  top: 13px;
  right: 10px;
  padding: 2px;
}

.cart-amount {
  border-color: var(--main-top);
  color: #fff;
  background: #f10d0d;
}

.footer ion-toolbar {
  --background: var(--footer-background);
  --color: var(--footer-text);
  box-shadow: var(--toolbar-shadow);
  --min-height: 36px;
}
.footer ion-toolbar ion-buttons ion-button.button-clear {
  --color: var(--main-top-text);
  --color-activated: var(--main-top-text);
  --border-radius: 0;
}
.footer ion-toolbar ion-buttons ion-button {
  width: 100%;
  height: inherit;
}
.footer ion-toolbar ion-buttons ion-button .btn-body {
  font-size: 12px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer ion-toolbar ion-buttons ion-button .btn-body ion-img {
  height: 30px;
}
.footer ion-button.footer-button.button-has-icon-only {
  font-size: 17px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}
.footer ion-button ion-icon.small-icon {
  font-size: 20px;
}
.footer ion-badge {
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: auto;
  left: 0;
  right: 0;
  padding: 2px;
  width: -moz-fit-content;
  width: fit-content;
  --background: var(--button-a-background);
  --color: var(--button-a-text);
}

.company-title {
  white-space: pre-line;
  font-size: 13px !important;
  line-height: 0.9;
  max-height: 38px;
}

.company-box .btn-body {
  min-height: 30px;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/core/components/app-footer/app-footer.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,6BAAA;EACA,WAAA;EACA,mBAAA;AAAF;;AAKE;EACE,sCAAA;EACA,2BAAA;EAEA,iCAAA;EAoEA,kBAAA;AAtEJ;AAUI;EACE,6BAAA;EACA,uCAAA;EACA,kBAAA;AARN;AAuBM;EACE,WAAA;EACA,eAAA;AArBR;AAwBQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAtBV;AAwBU;EACE,YAAA;AAtBZ;AAoDE;EAIE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AArDJ;AAwDE;EACE,eAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EAEA,wCAAA;EACA,6BAAA;AAzDJ;;AAsEA;EACE,qBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AAnEF;;AAsEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAnEF","sourcesContent":["ion-footer {\n  z-index: 999;\n}\n\n\n.cart-amount {\n  font-size: 1rem;\n  border: 1px solid;\n  border-radius: 10px;\n  min-width: 22px;\n  height: auto;\n  text-align: center;\n  position: absolute;\n  top: 13px;\n  right: 10px;\n  padding: 2px;\n}\n\n.cart-amount {\n  border-color: var(--main-top);\n  color: #fff;\n  background: #f10d0d;\n}\n\n\n.footer {\n  ion-toolbar {\n    --background: var(--footer-background);\n    --color: var(--footer-text);\n\n    box-shadow: var(--toolbar-shadow);\n\n    //border-top-right-radius: 15px;\n    //border-top-left-radius: 15px;\n\n    //width: 99%;\n    //margin: auto;\n\n    ion-buttons ion-button.button-clear {\n      --color: var(--main-top-text);\n      --color-activated: var(--main-top-text);\n      --border-radius: 0;\n    }\n\n    ion-buttons {\n      //ion-button.big-button {\n      //  padding: 3px 0px;\n      //\n      //  .btn-body{\n      //    background: var(--button-a-background);\n      //    border-radius: 45px;\n      //    height: 70px;\n      //    width: 70px;\n      //  }\n      //}\n\n      ion-button {\n        width: 100%;\n        height: inherit;\n        //padding: 5px 0px;\n\n        .btn-body {\n          font-size: 12px;\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n\n          ion-img {\n            height: 30px;\n          }\n        }\n      }\n    }\n\n    //  //width: fit-content;\n    //  //  font-size: 13px;\n    //  width: 100%;\n    //  height: 100%;\n    //  --border-radius: 0;\n    //\n    //  .btn-body {\n    //    font-size: 15px;\n    //\n    //    ion-label {\n    //      font-size: 12px;\n    //    }\n    //\n    //    div {\n    //      width: 100%;\n    //      text-align: center;\n    //    }\n    //  }\n    //}\n\n\n    --min-height: 36px;\n  }\n\n  ion-button.footer-button.button-has-icon-only {\n    //margin-right: auto;\n    //margin-left: auto;\n\n    font-size: 17px;\n    --padding-start: 0;\n    --padding-end: 0;\n    --padding-top: 0;\n    --padding-bottom: 0;\n  }\n\n  ion-button ion-icon.small-icon {\n    font-size: 20px;\n  }\n\n  ion-badge {\n    font-size: 11px;\n    position: absolute;\n    //top: 33px;\n    bottom: 0px;\n    margin: auto;\n    left: 0;\n    right: 0;\n    padding: 2px;\n    width: fit-content;\n\n    --background: var(--button-a-background);\n    --color: var(--button-a-text);\n  }\n}\n\n@media screen and (min-width: 1000px) {\n\n  .footer {\n    ion-toolbar {\n      //--min-height: 70px;\n    }\n  }\n}\n\n.company-title {\n  white-space: pre-line;\n  font-size: 13px !important;\n  line-height: 0.9;\n  max-height: 38px;\n}\n\n.company-box .btn-body {\n  min-height: 30px;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
